import { render, staticRenderFns } from "./LocationMapping.vue?vue&type=template&id=60620eec"
import script from "./LocationMapping.vue?vue&type=script&lang=js"
export * from "./LocationMapping.vue?vue&type=script&lang=js"
import style0 from "./LocationMapping.vue?vue&type=style&index=0&id=60620eec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports